export enum SEARCH_DIRECTIONS {
  PREV,
  NEXT,
}

export const enum GRID_MODE {
  EDIT,
  VIEW,
}

export const $ROW_HIDDEN_ACTIVE_ID = '$ROW_HIDDEN_ACTIVE_ID';
export const $ROW_HIDDEN_ID = '$ROW_HIDDEN_ID';
export const $ROW_HIDDEN_LABEL = '$ROW_HIDDEN_LABEL';

export enum FEATURES {
  KEYDOWN = 'KEYDOWN',
  CONTEXT_MENU = 'CONTEXT_MENU',
  FIND_INPUT = 'FIND_INPUT',
  CHECKBOX = 'CHECKBOX',
  LABEL = 'LABEL',
  SORTING = 'SORTING',
  MOVE_COLUMN = 'MOVE_COLUMN',
}

export const DEFAULT_COLUMN_WIDTH = 400 as const;
export const MIN_COLUMN_WIDTH = 50 as const;
export const CHECKBOX_COLUMN_WIDTH = 35 as const;
export const ROW_HEIGHT = 30 as const;
export const SEARCH_INPUT_MIN_WIDTH = 350 as const;
export const DATASET_ID_PREFIX = 'dataset-' as const;
export const CELL_ID_PREFIX = 'datasetCell' as const;

export const gridFeatures = [
  FEATURES.CONTEXT_MENU,
  FEATURES.KEYDOWN,
  FEATURES.FIND_INPUT,
  FEATURES.SORTING,
  FEATURES.CHECKBOX,
  FEATURES.LABEL,
  FEATURES.MOVE_COLUMN,
];

export const formGridFeatures = [
  FEATURES.KEYDOWN,
  FEATURES.FIND_INPUT,
  FEATURES.LABEL,
];

export const DEFAULT_PRESET = 'default';

export const DRAG_SCROLL_EDGE = 40;
export const DRAG_SCROLL_SPEED = 25;
